import { Box, Center, Spinner } from "@chakra-ui/react";
import { useStores } from "../store/store_context";
import { observer } from "mobx-react-lite";



const LoaderIndicator = observer(() => {

    const { pageStore } = useStores();
  
    return (
            
            <Box>
              {pageStore.isLoading ? (
              <Center w="100%" h="400px">
                <Spinner size="xl" color="white" thickness="4px" />
              </Center>):(<Box></Box>)}
            </Box>
          );
})

export default LoaderIndicator;